import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import {
  migrationServices,
  migrationServicesHeading,
  migrationServicesSubheading,
} from "./data/migrationServices";
import { useNavigate, Link } from "react-router-dom";

export default function HomeMigrationServicesSection() {
  const navigate = useNavigate();
  return (
    <section className="py-24 bg-[#EEF5FF]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="lg:w-1/3 lg:sticky lg:top-24">
            <motion.h2
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4 }}
              className="text-4xl md:text-5xl font-black mb-6 tracking-tight leading-none text-slate-900 whitespace-pre-line"
            >
              {migrationServicesHeading}
            </motion.h2>
            <p className="text-slate-600 text-sm max-w-sm leading-relaxed mb-10">
              {migrationServicesSubheading}
            </p>
            <Link
              to="/services"
              className="flex justify-center gap-2 items-center mx-auto shadow-xl text-lg bg-gray-50 backdrop-blur-md lg:font-semibold isolation-auto before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-gradient-to-br before:from-[#2654AA] before:to-[#49A2F7] hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-4 py-2 overflow-hidden rounded-full group"
            >
              <span className="relative z-10">Explore More</span>
              <svg
                className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-gray-50 text-gray-50 ease-linear duration-300 rounded-full p-2 rotate-45"
                viewBox="0 0 16 19"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                  className="fill-gray-800 group-hover:fill-gray-800"
                ></path>
              </svg>
            </Link>
          </div>

          <div className="lg:w-2/3 w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
              {migrationServices.map((service, index) => (
                <motion.article
                  key={service.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.08 }}
                  className="group relative p-8 rounded-3xl bg-white border border-slate-200 transition-all h-full shadow-sm overflow-hidden"
                  onClick={() => { if (service.url) navigate(service.url); }}
                  style={{ cursor: service.url ? "pointer" : "default" }}
                >
                  <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out bg-gradient-to-br from-[#2654AA] to-[#49A2F7]" />

                  <div className="relative z-10 w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center mb-6 transition-colors duration-300 group-hover:bg-white/20">
                    <img src={service.icon} alt={service.title} className="w-10 h-10 object-contain" loading="lazy" decoding="async" />
                  </div>

                  <h3 className="relative z-10 text-lg font-black mb-3 tracking-tight text-slate-900 group-hover:text-white transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="relative z-10 text-slate-600 text-sm leading-relaxed group-hover:text-white transition-colors duration-300">
                    {service.description}
                  </p>
                </motion.article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
